import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCancel: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setIsCancel: (state, action) => {
      state.isCancel = action.payload;
    },
  },
});

export const { setIsCancel } = profileSlice.actions;

export default profileSlice.reducer;
